import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map, filter } from 'rxjs/operators';
import { LoadReleaseSuccess } from '../action-creators';
import { GetTracks } from '@webapp/store/tracks/action-creators';
import { LOAD_RELEASE_SUCCESS } from '../actions';
import { Action } from 'redux';

export const successLoadReleaseEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, LoadReleaseSuccess>(LOAD_RELEASE_SUCCESS),
    filter((action) => !!action.fetchTracks && !!action.release.id),
    map((action) => {
      return new GetTracks(action.release.id!);
    })
  );
